import { FC, useState } from 'react';
import { MdInfoOutline } from '@react-icons/all-files/md/MdInfoOutline';

import { BottomSheet } from 'components/design-system/BottomSheet';
import { formatPrice } from 'utils/text-helpers';

import { CommissionDetails } from './CommissionDetails';

export type PayoutModalProps = {
  earnings: number;
  commission: number;
  sellingPrice: number;
  sellerFee: number;
  minimalFee: number;
  onClose: () => void;
};

export const PayoutBottomSheet: FC<PayoutModalProps> = ({
  onClose,
  commission,
  sellerFee,
  earnings,
  sellingPrice,
  minimalFee
}) => {
  const [isCommissionDetailsVisible, setCommissionDetailsVisible] = useState(false);

  const showCommissionDetails = () => setCommissionDetailsVisible(true);
  const hideCommissionDetails = () => setCommissionDetailsVisible(false);

  const formattedEarnings = formatPrice(earnings);
  const formattedCommission = formatPrice(commission);
  const formattedSellingPrice = formatPrice(sellingPrice);

  return (
    <BottomSheet
      className='pb-6 pb-md-7'
      onClose={onClose}
      onBack={isCommissionDetailsVisible ? hideCommissionDetails : undefined}
      title={
        <div className='riforma-medium text-center opacity-60 fs-14px line-height-16px letter-spacing-08'>
          {isCommissionDetailsVisible ? 'COMMISSION DETAILS' : 'PAYOUT'}
        </div>
      }
    >
      <div className='riforma-regular'>
        {isCommissionDetailsVisible ? (
          <CommissionDetails
            title='Negotiated sale price'
            commission={commission}
            minimalFee={minimalFee}
            sellerFee={sellerFee}
            sellingPrice={sellingPrice}
          />
        ) : (
          <div className='d-flex flex-column align-items-center'>
            <div className='opacity-90 text-success fs-32px line-height-40 letter-spacing-007 my-4'>
              {formattedEarnings}
            </div>
            <div className='my-6' />
            <div className='d-flex justify-content-between opacity-90 w-100 letter-spacing-004'>
              <span>Selling Price</span>
              <span>{formattedSellingPrice}</span>
            </div>
            <div className='d-flex justify-content-between opacity-60 w-100 mt-2 letter-spacing-004'>
              <div role='button' onClick={showCommissionDetails} className='d-flex align-items-center'>
                Bezel Commission <MdInfoOutline className='ms-1' size={12} />
              </div>
              <span>{formattedCommission}</span>
            </div>
          </div>
        )}
        <hr className='opacity-10 mt-4' />
        <div className='fs-16px letter-spacing-005 line-height-18px riforma-medium text-success d-flex justify-content-between'>
          <span>Earnings</span>
          <span>{formattedEarnings}</span>
        </div>
      </div>
    </BottomSheet>
  );
};
